import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../../firebase';

function AddResult({hostcupId, roundId, draw, homeTeam, awayTeam, kampNr}) {

    const [homeGoals, setHomeGoals] = useState(0);
    const [awayGoals, setAwayGoals] = useState(0);
    const [homePoints, setHomePoints] = useState(0);
    const [awayPoints, setAwayPoints] = useState(0);
    const [homeTeamN, setHomeTeamN] = useState(homeTeam)
    const [awayTeamN, setAwayTeamN] = useState(awayTeam)

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const [isAdded, setIsAdded] = useState(false);

    useEffect(() => {

        const resultRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("results");
        resultRef.where("draw", "==", draw).onSnapshot(({docs}) => {
            const results = docs.map(doc => {
                return {id: doc.id, ...doc.data()}
            });
            const isResultAdded = results.filter(result => {
                return result.home_team === homeTeam && result.away_team === awayTeam;
            })
            console.log(isResultAdded.length > 0, "Is Result Added?")
            if (isResultAdded.length > 0) {
                setIsAdded(true)
            }
        })


    }, [])

    useEffect(() => {

        if (homeGoals > awayGoals) {
            if (homeGoals-2 > awayGoals) {
                setHomePoints(3);
                setAwayPoints(0)
            } else {
                setHomePoints(2);
                setAwayPoints(0)
            }

        } else if (awayGoals > homeGoals) {
            if (awayGoals-2 > homeGoals) {
                setAwayPoints(3);
                setHomePoints(0)
            } else {
                setAwayPoints(2);
                setHomePoints(0)
            }

        } else if (homeGoals === awayGoals) {
            setHomePoints(1);
            setAwayPoints(1)
        }

    }, [homeGoals, awayGoals])

    async function submitHandler(e) {
        e.preventDefault();
        try {
            const resultRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("results");
            const data = {
                home_goals: +homeGoals,
                away_goals: +awayGoals,
                home_points: +homePoints,
                away_points: +awayPoints,
                draw,
                home_team: homeTeamN,
                away_team: awayTeamN,
                kamp_nr: kampNr
            }
            resultRef.add(data);
            setMessage("Lagt til!")
        } catch (error) {
            setError("Kunne ikke legge til resultat")
        }
    }

    return (
        <React.Fragment>
            {isAdded ? <p className="font-weight-bold mb-3">{`Trekning ${draw} Lag ${homeTeam} mot ${awayTeam} Lagt til allerede`}</p> : 
                <form onSubmit={submitHandler}>
                    <div className="row my-3">
                        <div className="col-12">
                            <p className="font-weight-bold">Trekning {draw} Lag {homeTeam} mot {awayTeam} <span className={isAdded ? "text-danger" : ""}>{isAdded ? "Lagt til allerede" : "Ikke lagt til"}</span></p>
                        </div>
                        <div className="col-md-4 col-lg-2">
                            <label>Hjemmemål</label>
                            <input type="number" className="form-control mb-2" value={homeGoals} onChange={e => setHomeGoals(e.target.value)} />
                        </div>
                        <div className="col-md-4 col-lg-2">
                            <label>Bortemål</label>
                            <input type="number" className="form-control mb-2" value={awayGoals} onChange={e => setAwayGoals(e.target.value)} />
                        </div>
                        <div className="col-md-4 col-lg-2">
                            <label>Hjemmelag</label>
                            <input className="form-control mb-2" value={homeTeamN} onChange={e => setHomeTeamN(e.target.value)} />
                        </div>
                        <div className="col-md-4 col-lg-2">
                            <label>Bortelag</label>
                            <input className="form-control mb-2" value={awayTeamN} onChange={e => setAwayTeamN(e.target.value)} />
                        </div>
                        <div className="col-md-4 col-lg-1">
                            <label>Hpoeng</label>
                            <input type="number" className="form-control mb-2" value={homePoints} onChange={e => setHomePoints(e.target.value)} />
                        </div>
                        <div className="col-md-4 col-lg-1">
                            <label>Bpoeng</label>
                            <input type="number" className="form-control mb-2" value={awayPoints} onChange={e => setAwayPoints(e.target.value)} />
                        </div>
                        <div className="col-lg-2">
                            {message && <div className="alert alert-success">{message}</div>}
                            {error && <div className="alert alert-danger">{error}</div>}
                            <button className="btn btn-success btn-block btn-sm">Lagre</button>
                        </div>
                    </div>
                    <hr />
                </form>
            }
        </React.Fragment>

    )

}
export default AddResult